import { 
    Directive, 
    ElementRef, 
    HostListener, 
    Input, 
    Renderer2, 
    OnDestroy 
  } from '@angular/core';
  
  @Directive({
    selector: '[appCopyClipboard]',
    standalone: true
  })
  export class CopyClipboardDirective implements OnDestroy {
    @Input('appCopyClipboard') copyValue!: string;
    private tooltip!: HTMLElement;
    private timeoutId: any;
  
    constructor(
      private readonly el: ElementRef,
      private readonly renderer: Renderer2
    ) {}
  
    @HostListener('mouseenter') onMouseEnter() {
      this.showTooltip('Copy');
    }
  
    @HostListener('mouseleave') onMouseLeave() {
      this.removeTooltip();
    }
  
    @HostListener('click') onClick() {
      this.copyToClipboard();
      this.showTooltip('Copied!');
      this.removeTooltipAfterDelay();
    }
  
    private createTooltip(text: string) {
      this.tooltip = this.renderer.createElement('div');
      this.tooltip.textContent = text;
      this.renderer.addClass(this.tooltip, 'custom-tooltip');
      this.renderer.appendChild(document.body, this.tooltip);
      
      const hostPos = this.el.nativeElement.getBoundingClientRect();
      this.tooltip.style.top = `${hostPos.top - 30}px`;
      this.tooltip.style.left = `${hostPos.left + hostPos.width - 5}px`;
    }
  
    private showTooltip(text: string) {
      if (this.tooltip) this.removeTooltip();
      this.createTooltip(text);
    }
  
    private removeTooltip() {
      if (this.tooltip) {
        this.renderer.removeChild(document.body, this.tooltip);
        this.tooltip = null!;
      }
    }
  
    private async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.copyValue);
      } catch (err) {
        console.error('Failed to copy text:', err);
      }
    }
  
    private removeTooltipAfterDelay() {
      this.timeoutId = setTimeout(() => this.removeTooltip(), 1000);
    }
  
    ngOnDestroy() {
      this.removeTooltip();
      clearTimeout(this.timeoutId);
    }
  }